import React from 'react';
import Link from '../links/Link/Link';
import classNames from 'classnames';

function CardContentLink({ href, title, target, children }) {
  const Element = href ? Link : 'div';

  const cardContentLinkClasses = classNames({
    content__link: href,
    content__title: !href
  });

  return (
    <Element className={cardContentLinkClasses} href={href} title={title} target={target}>
      {children}
    </Element>
  );
}

export default CardContentLink;
